import React from "react";
import { Download } from "react-bootstrap-icons";
// import { NavLink } from "react-router-dom";
// import {
//   pathNewsSubAll,
//   pathNewsSubImportant,
//   pathNewsSubPinned,
// } from "../../../common/config/vars";
import { getAttachImgSrc, IDemFile } from "../logics/demandFiles";

interface IDemandFile {
  file: IDemFile;
  urlPrefix: string;
}

export const DemandFile = ({ file, urlPrefix }: IDemandFile) => {
  return (
    <li
      className="list-group-item d-flex mb-2"
      style={{ borderRadius: "12px", padding: "11px" }}
    >
      <a href={urlPrefix + file.url} target="_blank" rel="noopener noreferrer">
        <img
          src={getAttachImgSrc(file.mime, file.base64)}
          style={{ maxWidth: "40px", borderRadius: "12px" }}
          alt="заявка.jpg"
        />
      </a>
      <div className="mr-auto ml-3 mb-auto mt-auto">{file.name}</div>
      <div className="ml-auto mb-auto mt-auto">
        <a href={urlPrefix + file.url} download>
          <Download />
        </a>
      </div>
    </li>
  );
};
